// eslint-disable-next-line no-unused-vars
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchMultipleNpmStats } from "../services/activityService.js";
// import {
//   SiGithub,
//   SiNpm,
//   SiDiscord,
//   SiYoutube,
//   SiX,
//   SiLinkedin,
//   SiBlender,
//   SiUnity,
// } from "react-icons/si";
import { FiArrowUpRight } from "react-icons/fi";
import "./minor.css";

export const TopProdEl = ({ children, className = "" }) => {
  return <div className={`top-prod-el ${className}`}>{children}</div>;
};

export const BtnCategoryIn = ({ category, isActive, onClick, children }) => {
  return (
    <button
      className={`btn-category-in ${isActive ? "active" : ""}`}
      onClick={() => onClick(category)}
    >
      {children}
    </button>
  );
};

export const HubArticle = ({ article, onClick, authors = [] }) => {
  const author = authors.find((a) => a.id === article.authorId);

  return (
    <div className="hub-article" onClick={() => onClick(article)}>
      <div className="hub-article-content">
        <h4>{article.title}</h4>
        <p>{article.content.substring(0, 80)}...</p>
        <div className="hub-article-meta">
          {author && <span>{author.nickname}</span>}
          <span>{article.date}</span>
        </div>
      </div>
    </div>
  );
};

export const DateComponent = ({ date, className = "" }) => {
  return <span className={`date-component ${className}`}>{date}</span>;
};

export const LinkStyled = ({ href, name, arrow, className = "" }) => {
  return (
    <Link to={href} className={`link-styled ${className}`}>
      <span className="link-arrow">{arrow}</span>
      <span className="link-text">{name}</span>
    </Link>
  );
};

export const PlatformLink = ({ href, icon, name, desc, url, iconClass }) => {
  return (
    <a
      href={href || url}
      className="platform-link"
      target="_blank"
      rel="noopener noreferrer"
    >
      <div
        className={`platform-icon ${icon || iconClass || ""}`}
        style={icon && !iconClass ? { backgroundImage: `url(${icon})` } : {}}
      ></div>
      <div className="platform-info">
        <span className="platform-name">{name}</span>
        <span className="platform-desc">{desc}</span>
      </div>
    </a>
  );
};

export const PlatformCategory = ({ title, platforms }) => (
  <div className="platform-category">
    <h3>{title}</h3>
    <div className="platform-links">
      {platforms.map((platform, index) => (
        <PlatformLink
          key={index}
          name={platform.name}
          desc={platform.desc}
          url={platform.url}
          icon={platform.icon}
          iconClass={platform.iconClass}
        />
      ))}
    </div>
  </div>
);

export const ActivityItem = ({ type, title, desc, linkTo, embedUrl }) => {
  // Jeśli to YouTube i mamy embedUrl, pokaż odtwarzacz
  if (type === "youtube" && embedUrl) {
    return (
      <div className="activity-item-youtube">
        <div className="activity-youtube-header">
          <div className={`activity-indicator ${type}`}></div>
          <div className="activity-content">
            <span className="activity-title">{title}</span>
            <span className="activity-desc">{desc}</span>
          </div>
        </div>
        <div className="youtube-embed-container">
          <iframe
            src={embedUrl}
            title={title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
        {linkTo && (
          <a
            href={linkTo}
            target="_blank"
            rel="noopener noreferrer"
            className="youtube-channel-link"
          >
            Zobacz kanał →
          </a>
        )}
      </div>
    );
  }

  // Standardowy ActivityItem dla innych typów
  const content = (
    <div className="activity-item-compact">
      <div className={`activity-indicator ${type}`}></div>
      <div className="activity-content">
        <span className="activity-title">{title}</span>
        <span className="activity-desc">{desc}</span>
      </div>
    </div>
  );

  return linkTo ? <Link to={linkTo}>{content}</Link> : content;
};

export const FeaturedNewsItem = ({ article, linkTo, authors = [] }) => {
  const author = authors.find((a) => a.id === article.authorId);

  return (
    <div className="clip-container">
      <Link to={linkTo}>
        <div className="featured-news-item">
          <div className="featured-news-image">
            <img src={`/images/${article.img}`} alt={article.title} />
          </div>
          <div className="featured-news-content">
            <h5 className="featured-news-title">{article.title}</h5>
            <div className="featured-news-meta">
              {author && (
                <span className="featured-news-author">{author.nickname}</span>
              )}
              <span className="featured-news-date">{article.date}</span>
            </div>
            <p className="featured-news-excerpt">
              {article.content.substring(0, 80)}...
            </p>
            <div className="featured-news-categories">
              {article.category.slice(0, 2).map((cat, idx) => (
                <span
                  key={`featured-${article.id}-${idx}`}
                  className="featured-category-pill"
                >
                  {cat}
                </span>
              ))}
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};

export const FilterButton = ({
  value,
  label,
  isActive,
  onClick,
  className = "",
  wrapperClassName = "",
}) => {
  return (
    <div className={wrapperClassName}>
      <button
        className={`filter-btn ${isActive ? "active" : ""} ${className}`}
        onClick={() => onClick(value)}
      >
        {label}
      </button>
    </div>
  );
};

export const ArticleCard = ({
  article,
  index,
  cardClass = "",
  compact = false,
  authors = [],
}) => {
  const author = authors.find((a) => a.id === article.authorId);
  const featuredClass = article.featured ? "featured-article" : "";
  const compactClass = compact ? "compact-card" : "";
  const finalCardClass =
    cardClass || `news-card card-${index + 1} ${featuredClass} ${compactClass}`;

  return (
    <Link
      key={article.id}
      to={`/article/${article.id}/${article.title
        .slice(0, -1)
        .replace(/[\s:]+/g, "-")
        .toLowerCase()}`}
      className={`${finalCardClass} search-input-border-clip`}
    >
      <div className="card-content-wrapper-bg">
        {article.img && !compact && (
          <div className="card-image">
            <img src={`/images/${article.img}`} alt={article.title} />
          </div>
        )}
        <div className="card-content">
          <h3>
            {compact
              ? article.title.substring(0, 60) +
                (article.title.length > 60 ? "..." : "")
              : article.title}
          </h3>
          <div className="card-meta">
            {author && <span className="card-author">{author.nickname}</span>}
            <span className="card-date">{article.date}</span>
          </div>
          {!compact && (
            <div className="card-tags">
              {article.category.slice(0, 3).map((tag, idx) => (
                <span key={`${article.id}-${idx}`} className="card-tag">
                  {tag}
                </span>
              ))}
            </div>
          )}
          <p>{article.content.substring(0, compact ? 60 : 100)}...</p>
        </div>
      </div>
    </Link>
  );
};

export const AchievementsPanel = ({ isOpen, onClose, achievements = {} }) => {
  const [npmStats, setNpmStats] = useState([]);

  // Pobierz statystyki NPM
  useEffect(() => {
    fetchMultipleNpmStats()
      .then((stats) => {
        setNpmStats(stats);
      })
      .catch((error) => {
        console.error("Error fetching NPM stats:", error);
      });
  }, []);

  // Oblicz całkowitą liczbę pobrań NPM
  const totalNpmDownloads =
    npmStats && npmStats.length > 0
      ? npmStats.reduce((total, pkg) => total + pkg.totalDownloads, 0)
      : 0;

  if (!isOpen) return null;

  return (
    <div className="achievements-overlay" onClick={onClose}>
      <div className="achievements-panel-border">
        <div
          className="achievements-panel"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="announcement-indicator"></div>
          <div className="announcement-header-type">
            <span className="announcement-label">Milestone'y</span>
            <button className="close-button" onClick={onClose}>
              ×
            </button>
          </div>
          <div className="achievements-content">
            {Object.entries(achievements).map(([category, data]) => (
              <div key={category} className="milestone-category">
                <h4 className="announcement-title">{data.title}</h4>
                <div className="milestone-progress-bar">
                  {data.milestones.map((milestone, index) => {
                    // Dla kategorii NPM, sprawdź dynamicznie czy milestone jest osiągnięty
                    let isAchieved = milestone.achieved;
                    if (category === "npm" && milestone.value) {
                      isAchieved = totalNpmDownloads >= milestone.value;
                    }

                    return (
                      <div key={index} className="milestone-item-wrapper">
                        <div
                          className={`milestone-item ${isAchieved ? "achieved" : "not-achieved"}`}
                        >
                          <div className="milestone-value">
                            {milestone.title}
                          </div>
                          {isAchieved && milestone.date && (
                            <div className="milestone-date">
                              {milestone.date}
                            </div>
                          )}
                        </div>
                        {index < data.milestones.length - 1 && (
                          <div className="milestone-connector"></div>
                        )}
                      </div>
                    );
                  })}
                </div>
                <div className="current-progress">
                  Aktualnie:{" "}
                  <span className="current-value">
                    {category === "npm"
                      ? totalNpmDownloads.toLocaleString()
                      : data.current.toLocaleString()}
                  </span>
                  {category === "npm" && (
                    <span className="progress-percentage">
                      {" "}
                      ({Math.round((totalNpmDownloads / 1000) * 100)}%)
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

// ─── FOOTER ──────────────────────────────────────────────────────────────────

const FAQ_ITEMS = [
  {
    q: "Czym jest QuickBlocksUI?",
    a: "Otwarto-źródłowa biblioteka komponentów React dostępna przez NPM (@twohandstudio/quickblocksui). Zawiera gotowe UI bloki z pełnym wsparciem TypeScript i dark/light mode.",
  },
  {
    q: "Czy jesteś dostępny do współpracy?",
    a: "Aktualnie nie przyjmuję zleceń komercyjnych, ale chętnie odpiszę na pytania dotyczące open-source lub game-dev. Najszybciej przez Discord.",
  },
  {
    q: "Jak zgłosić błąd lub sugestię?",
    a: "Otwórz issue na GitHubie w odpowiednim repozytorium lub opisz problem na Discordzie. Staram się odpowiadać w ciągu 48 godzin.",
  },
  {
    q: "Gdzie śledzić aktualizacje projektów?",
    a: "Strona News zawiera devlogi, release notes i ogłoszenia. Sekcja Roadmap pokazuje planowane milestone'y dla każdego aktywnego projektu.",
  },
  {
    q: 'Czym różni się "Aktywny" od "W Rozwoju"?',
    a: '"Aktywny" oznacza stabilną, wydaną wersję. "W Rozwoju" to projekt we wczesnej fazie — mogą pojawić się breaking changes przed pierwszym stable release.',
  },
  {
    q: "Czy mogę pobrać 3D assety?",
    a: "Assety 3D modelowane w Blenderze są dostępne na moim profilu. Część jest darmowa, część na licencji CC. Szczegóły przy każdym projekcie.",
  },
];

const NAV_LINKS = [
  { label: "Strona główna", to: "/" },
  { label: "Projekty", to: "/projects" },
  { label: "Newsy & Devlogi", to: "/news" },
  { label: "Roadmapa", to: "/roadmap" },
  { label: "Aktualizacje", to: "/updates" },
  { label: "Profile", to: "/profiles" },
];

const PROJECT_LINKS = [
  { label: "QuickBlocksUI", to: "/projects", sub: "React · NPM" },
  { label: "Gry Unity", to: "/projects", sub: "C# · Game Dev" },
  { label: "Assety 3D", to: "/projects", sub: "Blender · CC" },
  { label: "Full-stack Web", to: "/projects", sub: "React · Node" },
];

// const SOCIAL_LINKS = [
//   { icon: SiGithub, label: "GitHub", href: "https://github.com/tehaque" },
//   { icon: SiNpm, label: "NPM", href: "https://www.npmjs.com/~tehaque" },
//   { icon: SiDiscord, label: "Discord", href: "#" },
//   { icon: SiYoutube, label: "YouTube", href: "#" },
//   { icon: SiX, label: "Twitter", href: "#" },
//   { icon: SiLinkedin, label: "LinkedIn", href: "#" },
// ];

export const Footer = ({ animate = true }) => {
  const year = new Date().getFullYear();

  return (
    <footer className={`site-footer${animate ? " animate-on-scroll" : ""}`}>
      <div className="container">
        {/* ── Main grid ── */}
        <div className="sf-grid">
          {/* Brand */}
          <div className="sf-brand">
            <div className="sf-logo">
              TEHAQUE<span className="sf-logo-dot">.</span>DEV
            </div>
            <p className="sf-tagline">
              Niezależny developer z Polski — gry, open-source, 3D i web.
              Wszystko od konceptu do wdrożenia, solo.
            </p>
            {/* <div className="sf-disciplines">
              <span className="sf-discipline">
                <SiUnity size={13} /> Unity &amp; C#
              </span>
              <span className="sf-discipline">
                <SiBlender size={13} /> Blender 3D
              </span>
              <span className="sf-discipline">
                <span className="sf-react-dot" />
                React &amp; NPM
              </span>
            </div> */}
            {/* <div className="sf-socials">
              {SOCIAL_LINKS.map(({ icon: Icon, label, href }) => (
                <a
                  key={label}
                  href={href}
                  className="sf-social"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  title={label}
                >
                  <Icon size={18} />
                </a>
              ))}
            </div> */}
          </div>

          {/* Nawigacja */}
          <div className="sf-col">
            <div className="sf-col-title">Nawigacja</div>
            <div className="sf-links">
              {NAV_LINKS.map(({ label, to }) => (
                <Link key={to} to={to} className="sf-link">
                  {label}
                </Link>
              ))}
            </div>
          </div>

          {/* Projekty */}
          <div className="sf-col">
            <div className="sf-col-title">Projekty</div>
            <div className="sf-links">
              {PROJECT_LINKS.map(({ label, to, sub }) => (
                <Link key={label} to={to} className="sf-link sf-link--project">
                  <span>{label}</span>
                  <span className="sf-link-sub">{sub}</span>
                </Link>
              ))}
            </div>
          </div>

          {/* Open Source */}
          <div className="sf-col">
            <div className="sf-col-title">Open Source</div>
            <div className="sf-links">
              <a
                href="https://github.com/tehaque"
                className="sf-link sf-link--ext"
                target="_blank"
                rel="noopener noreferrer"
              >
                GitHub <FiArrowUpRight size={12} />
              </a>
              <a
                href="https://www.npmjs.com/~tehaque"
                className="sf-link sf-link--ext"
                target="_blank"
                rel="noopener noreferrer"
              >
                NPM packages <FiArrowUpRight size={12} />
              </a>
              <a
                href="https://github.com/twohandstudio/quickblocksui"
                className="sf-link sf-link--ext"
                target="_blank"
                rel="noopener noreferrer"
              >
                QuickBlocksUI repo <FiArrowUpRight size={12} />
              </a>
            </div>
          </div>
        </div>

        {/* ── FAQ ── */}
        <div className="sf-faq">
          <div className="sf-faq-header">
            <div className="sf-col-title">FAQ</div>
            <div className="sf-faq-line" />
          </div>
          <div className="sf-faq-grid">
            {FAQ_ITEMS.map(({ q, a }) => (
              <div key={q} className="sf-faq-item">
                <div className="sf-faq-q">{q}</div>
                <div className="sf-faq-a">{a}</div>
              </div>
            ))}
          </div>
        </div>

        {/* ── Bottom bar ── */}
        <div className="sf-bottom">
          <span className="sf-copy">
            © {year} tehaque.dev · Wszelkie prawa zastrzeżone
          </span>
          <span className="sf-made"></span>
          <span className="sf-copy"></span>
        </div>
      </div>
    </footer>
  );
};
